<i18n>
{
	"en": {
		"title": "Action Type"
	},
	"no": {
		"title": "Tiltakstype"
	}
}
</i18n>

<template>
	<t-combobox
		:title="$t('title')"
		:showCount="false"
		showPopoverOnFocus

		:searchValue="searchValue"
		:items="actionTypes"
		:selected="value"

		:disabled="disabled || hasNoActionTypes"

		:filterFunction="filterFunction"
		:sortFunction="sortFunction"

		@input="onInput"
		@change="onChange"
		@blur="onBlur"
	>
		<template #optionItemContent="slotProps">
			<div class="item">
				<div class="item-main-text">{{getItemDisplayText(slotProps.item)}}</div>
			</div>
		</template>
	</t-combobox>
</template>

<script>
import { mapActions } from '../store/newDeviation.store';
import { isValidNumber } from '@/core';

export default {
	name: 'ActionTypeInput',
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			actionTypes: [],
			searchValue: '',
		};
	},

	computed: {
		hasNoActionTypes() {
			return !this.actionTypes || this.actionTypes.length === 0;
		},
	},

	watch: {
		value: {
			immediate: true,
			handler(actionType) {
				if (!actionType || Object.keys(actionType).length === 0) {
					this.searchValue = '';
				} else if (isValidNumber(actionType.id)) {
					this.searchValue = this.getItemDisplayText(actionType);
				}
			}
		}
	},

	async created() {
		this.actionTypes = await this.getActionTypes();
	},

	methods: {
		...mapActions(['getActionTypes']),
		onInput(searchValue) {
			this.searchValue = searchValue;
		},

		onChange(event) {
			if (event && isValidNumber(event.id)) {
				this.searchValue = this.getItemDisplayText(event);
				this.$emit('change', event);
			} else
				this.$emit('change', undefined);
		},

		onBlur() {
			if (this.searchValue === '') {
				this.$emit('change', undefined);
				return;
			}
			let matchingActionType = this.actionTypes.find(
				matchingActionType => (
					this.searchValue.toLowerCase() === matchingActionType[this.$i18n.locale].toLowerCase() ||
					this.searchValue === `${matchingActionType.id}`
				)
			);
			if (matchingActionType && matchingActionType !== this.value) {
				this.$emit('change', matchingActionType);
			} else {
				this.searchValue = this.getItemDisplayText(this.value);
			}
		},

		getItemDisplayText(item) {
			if (!item) return '';
			let id = isValidNumber(item.id) && `${item.id}` || '';
			let name = item[this.$i18n.locale] || item.en || '';
			if (id && name) return `${id} - ${name}`;
			else return id || name;
		},

		filterFunction(actionType) {
			return	`${actionType.id}`.includes(this.searchValue)
				|| actionType[this.$i18n.locale].toLowerCase().includes(this.searchValue.toLowerCase());
		},
		sortFunction: (a, b) => {
			if (a.id < b.id) return -1;
			if (a.id > b.id) return 1;
			return 0;
		},
	}
};
</script>
